/**
 * 对应语言翻译 ISO-639
 *
 * 谷歌翻译 iso-639
 */
import { Language } from '@/server/employee_request'

export const iso639 = [
  { Abkhazian: 'ab' },
  { Afar: 'aa' },
  { Afrikaans: 'af' },
  { Akan: 'ak' },
  { Albanian: 'sq' },
  { Amharic: 'am' },
  { Arabic: 'ar' },
  { Aragonese: 'an' },
  { Armenian: 'hy' },
  { Assamese: 'as' },
  { Avaric: 'av' },
  { Avestan: 'ae' },
  { Aymara: 'ay' },
  { Azerbaijani: 'az' },
  { Bambara: 'bm' },
  { Bashkir: 'ba' },
  { Basque: 'eu' },
  { Belarusian: 'be' },
  { 'Bengali, Bangla': 'bn' },
  { Bihari: 'bh' },
  { Bislama: 'bi' },
  { Bosnian: 'bs' },
  { Breton: 'br' },
  { Bulgarian: 'bg' },
  { Burmese: 'my' },
  { Catalan: 'ca' },
  { Chamorro: 'ch' },
  { Chechen: 'ce' },
  { 'Chichewa, Chewa, Nyanja': 'ny' },
  { Chinese: 'zh-CN' },
  { Chuvash: 'cv' },
  { Cornish: 'kw' },
  { Corsican: 'co' },
  { Cree: 'cr' },
  { Croatian: 'hr' },
  { Czech: 'cs' },
  { Danish: 'da' },
  { 'Divehi, Dhivehi, Maldivian': 'dv' },
  { Dutch: 'nl' },
  { Dzongkha: 'dz' },
  { English: 'en' },
  { Esperanto: 'eo' },
  { Estonian: 'et' },
  { Ewe: 'ee' },
  { Faroese: 'fo' },
  { Fijian: 'fj' },
  { Finnish: 'fi' },
  { French: 'fr' },
  { 'Fula, Fulah, Pulaar, Pular': 'ff' },
  { Galician: 'gl' },
  { 'Gaelic (Scottish)': 'gd' },
  { 'Gaelic (Manx)': 'gv' },
  { Georgian: 'ka' },
  { German: 'de' },
  { Greek: 'el' },
  { Greenlandic: 'kl' },
  { Guarani: 'gn' },
  { Gujarati: 'gu' },
  { 'Haitian Creole': 'ht' },
  { Hausa: 'ha' },
  { Hebrew: 'he' },
  { Herero: 'hz' },
  { Hindi: 'hi' },
  { 'Hiri Motu': 'ho' },
  { Hungarian: 'hu' },
  { Icelandic: 'is' },
  { Ido: 'io' },
  { Igbo: 'ig' },
  { Indonesian: 'id' },
  { Interlingua: 'ia' },
  { Interlingue: 'ie' },
  { Inuktitut: 'iu' },
  { Inupiaq: 'ik' },
  { Irish: 'ga' },
  { Italian: 'it' },
  { Japanese: 'ja' },
  { Javanese: 'jv' },
  { 'Kalaallisut, Greenlandic': 'kl' },
  { Kannada: 'kn' },
  { Kanuri: 'kr' },
  { Kashmiri: 'ks' },
  { Kazakh: 'kk' },
  { Khmer: 'km' },
  { Kikuyu: 'ki' },
  { 'Kinyarwanda (Rwanda)': 'rw' },
  { Kirundi: 'rn' },
  { Kyrgyz: 'ky' },
  { Komi: 'kv' },
  { Kongo: 'kg' },
  { Korean: 'ko' },
  { Kurdish: 'ku' },
  { Kwanyama: 'kj' },
  { Lao: 'lo' },
  { Latin: 'la' },
  { 'Latvian (Lettish)': 'lv' },
  { 'Limburgish ( Limburger)': 'li' },
  { Lingala: 'ln' },
  { Lithuanian: 'lt' },
  { 'Luga-Katanga': 'lu' },
  { 'Luganda, Ganda': 'lg' },
  { Luxembourgish: 'lb' },
  { Manx: 'gv' },
  { Macedonian: 'mk' },
  { Malagasy: 'mg' },
  { Malay: 'ms' },
  { Malayalam: 'ml' },
  { Maltese: 'mt' },
  { Maori: 'mi' },
  { Marathi: 'mr' },
  { Marshallese: 'mh' },
  { Moldavian: 'mo' },
  { Mongolian: 'mn' },
  { Nauru: 'na' },
  { Navajo: 'nv' },
  { Ndonga: 'ng' },
  { 'Northern Ndebele': 'nd' },
  { Nepali: 'ne' },
  { Norwegian: 'no' },
  { 'Norwegian bokmål': 'nb' },
  { 'Norwegian nynorsk': 'nn' },
  { Nuosu: 'ii' },
  { Occitan: 'oc' },
  { Ojibwe: 'oj' },
  { 'Old Church Slavonic, Old Bulgarian': 'cu' },
  { Oriya: 'or' },
  { 'Oromo (Afaan Oromo)': 'om' },
  { Ossetian: 'os' },
  { Pāli: 'pi' },
  { 'Pashto, Pushto': 'ps' },
  { 'Persian (Farsi)': 'fa' },
  { Polish: 'pl' },
  { Portuguese: 'pt' },
  { 'Punjabi (Eastern)': 'pa' },
  { Quechua: 'qu' },
  { Romansh: 'rm' },
  { Romanian: 'ro' },
  { Russian: 'ru' },
  { Sami: 'se' },
  { Samoan: 'sm' },
  { Sango: 'sg' },
  { Sanskrit: 'sa' },
  { Serbian: 'sr' },
  { 'Serbo-Croatian': 'sh' },
  { Sesotho: 'st' },
  { Setswana: 'tn' },
  { Shona: 'sn' },
  { 'Sichuan Yi': 'ii' },
  { Sindhi: 'sd' },
  { Sinhalese: 'si' },
  { Siswati: 'ss' },
  { Slovak: 'sk' },
  { Slovenian: 'sl' },
  { Somali: 'so' },
  { 'Southern Ndebele': 'nr' },
  { Spanish: 'es' },
  { Sundanese: 'su' },
  { 'Swahili (Kiswahili)': 'sw' },
  { Swedish: 'sv' },
  { Tagalog: 'tl' },
  { Tahitian: 'ty' },
  { Tajik: 'tg' },
  { Tamil: 'ta' },
  { Tatar: 'tt' },
  { Telugu: 'te' },
  { Thai: 'th' },
  { Tibetan: 'bo' },
  { Tigrinya: 'ti' },
  { Tonga: 'to' },
  { Tsonga: 'ts' },
  { Turkish: 'tr' },
  { Turkmen: 'tk' },
  { Twi: 'tw' },
  { Uyghur: 'ug' },
  { Ukrainian: 'uk' },
  { Urdu: 'ur' },
  { Uzbek: 'uz' },
  { Venda: 've' },
  { Vietnamese: 'vi' },
  { Volapük: 'vo' },
  { Wallon: 'wa' },
  { Welsh: 'cy' },
  { Wolof: 'wo' },
  { 'Western Frisian': 'fy' },
  { Xhosa: 'xh' },
  { Yiddish: 'yi' },
  { Yoruba: 'yo' },
  { 'Zhuang, Chuang': 'za' },
  { Zulu: 'zu' }
]

/**
 * 语言 多语言
 *
 * -> returns
 */
export const ISO639List = [
  { text: 'English', value: 'en', re: Language.English },
  { text: 'italiano', value: 'it', re: Language.Italy },
  //印第语
  { text: 'हिन्दी', value: 'hi', re: Language.Hindi },
  { text: 'Indonesia', value: 'id', re: Language.Indonesian },
  { text: 'Tiếng Việt', value: 'vi', re: Language.Vietnamese },
  { text: 'ไทย', value: 'th', re: Language.Thai },
  { text: '日本語', value: 'ja', re: Language.Japanese },
  { text: 'português (Brasil)', value: 'pt', re: Language.Portuguese },
  { text: 'বাংলা (ভারত)', value: 'bn', re: Language.BengaliIndia },
  { text: 'монгол', value: 'mn', re: Language.Mongolian },
  //马来语
  { text: 'Melayu', value: 'ms', re: Language.Malay },
  //不支持
  { text: 'ພາສາລາວ', value: 'lo', re: Language.Laos },
  { text: 'Nederlands', value: 'nl', re: Language.Dutch },
  { text: '한국어', value: 'ko', re: Language.Korean },
  //支持fi
  { text: 'Filipino (Tagalog)', value: 'fil', re: Language.Filipino },
  //支持tk tr th
  { text: 'Tagalog (Filipino)', value: 'tl', re: Language.Filipino },
  { text: 'русский', value: 'ru', re: Language.Russian },
  { text: 'беларуская', value: 'be', re: Language.BelaRussian },
  { text: 'Deutsch', value: 'de', re: Language.German },
  { text: '中文', value: 'zh', re: Language.Chinese },
  //不支持
  { text: 'မြန်မာ', value: 'my', re: Language.Burmese },
  { text: 'español', value: 'es', re: Language.Spanish }
]
